import { z } from "zod";
import sceneObjectDataSchema from "./sceneObjectDataSchema";
import { vector3dSchema } from "../../primitivesSchema";
import apiPlacementSchema from "../../placementSchema";

const rectangleAnnotationDataSchema = sceneObjectDataSchema.extend({
    placement: apiPlacementSchema,
    corner1: vector3dSchema,
    corner2: vector3dSchema,
    depth: z.number(),
    extrudedDirection: vector3dSchema,
    fontSize: z.number().optional(),
    showAreaText: z.boolean().optional(),
    showVolume: z.boolean().optional()
  });

export default rectangleAnnotationDataSchema;
